module.exports = __webpack_public_path__ + "img/dm.d41090a0.png";